module.exports = __webpack_public_path__ + "static/media/space_moon.966d51e5.svg";